module.exports = __webpack_public_path__ + "media/site/images/ecommerce/ecommerce-start-selling-headphones-mobile@1x-aa8edc81e2e956fb0d383eaf3901de8b.png";